import { render, staticRenderFns } from "./shade-box.vue?vue&type=template&id=3c0b5640&scoped=true"
import script from "./shade-box.vue?vue&type=script&lang=js"
export * from "./shade-box.vue?vue&type=script&lang=js"
import style0 from "./shade-box.vue?vue&type=style&index=0&id=3c0b5640&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0b5640",
  null
  
)

export default component.exports